import { Tab } from './components/Tabs';

export const signalTypes = [
  {
    value: '1',
    label: 'Покупка',
  },
  {
    value: '2',
    label: 'Продажа',
  },
  {
    value: '3',
    label: 'Закрытие',
  },
];

export const tabs: Tab[] = [
  {
    id: 1,
    name: 'Рыночный сигнал',
    className: 'market-signal-tab',
  },
  {
    id: 2,
    name: 'Отложенный сигнал',
    className: 'delayed-signal-tab',
  },
  {
    id: 3,
    name: 'Пакетная заявка',
    className: 'package-signal-tab',
  },
  {
    id: 4,
    name: 'Портфельный сигнал',
    className: 'portfolio-signal-tab',
  },
  {
    id: 5,
    name: 'Лимитная заявка',
    className: 'limit-order',
  },
];
